// extracted by mini-css-extract-plugin
module.exports = {"item":"ZoraHeader_item__1-7fQ"};